import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
} from '@chakra-ui/react';
import { Form, Formik, FormikProps } from 'formik';
import _ from 'lodash';
import React from 'react';

import { Date } from '@finley-technologies/finley-types';

import { RecurringDateForm } from 'packages/common-frontend/components/RecurringDateForm/RecurringDateForm';
import { RelativeRecurringDateForm } from 'packages/common-frontend/components/RecurringDateForm/RelativeRecurringDateForm';

const { cloneDeep } = _;

export const EditRecurringDateModal: React.FC<{
  isOpen: boolean;
  onCancel: Function;
  onSave: Function;
  recurringDateConfig: Date.RecurringDate.Config;
  displayName: string;
}> = ({ isOpen, onCancel, onSave, recurringDateConfig, displayName }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onCancel();
      }}
      size="3xl"
    >
      <ModalOverlay />
      <ModalContent padding="20px" maxWidth="min-content" minWidth="3xl">
        <ModalHeader>Edit {displayName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <Formik
            initialValues={cloneDeep(recurringDateConfig)}
            onSubmit={(props) => {
              onSave(props);
            }}
          >
            {(formProps: FormikProps<Date.RecurringDate.Config>) => {
              return (
                <Form onSubmit={formProps.handleSubmit}>
                  <RecurringDateForm
                    savedConfig={formProps.values}
                    setSavedConfig={formProps.setValues}
                  />
                  <Flex padding-top="5px" justifyContent="center">
                    <Button
                      mr="5px"
                      onClick={() => {
                        formProps.submitForm();
                      }}
                    >
                      Done
                    </Button>
                    <Button onClick={() => onCancel()}>Cancel</Button>
                  </Flex>
                </Form>
              );
            }}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export const EditRelativeRecurringDateModal: React.FC<{
  isOpen: boolean;
  onCancel: Function;
  onSave: Function;
  relativeDateConfig: Date.RecurringDate.RelativeConfig;
  displayName: string;
  staticStartDateFormula?: string;
  staticEndDateFormula?: string;
}> = ({
  isOpen,
  onCancel,
  onSave,
  relativeDateConfig,
  displayName,
  staticStartDateFormula,
  staticEndDateFormula,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onCancel();
      }}
      size="3xl"
    >
      <ModalOverlay />
      <ModalContent padding="20px" maxWidth="min-content" minWidth="3xl">
        <ModalHeader>Edit {displayName}</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <Formik
            initialValues={cloneDeep(relativeDateConfig)}
            onSubmit={(props) => {
              onSave(props);
            }}
          >
            {(formProps: FormikProps<Date.RecurringDate.RelativeConfig>) => (
              <Form onSubmit={formProps.handleSubmit}>
                <RelativeRecurringDateForm
                  savedConfig={formProps.values}
                  setSavedConfig={formProps.setValues}
                  staticStartDateFormula={staticStartDateFormula}
                  staticEndDateFormula={staticEndDateFormula}
                />
                <Flex padding-top="5px" justifyContent="center">
                  <Button
                    mr="5px"
                    onClick={() => {
                      formProps.submitForm();
                    }}
                  >
                    Done
                  </Button>
                  <Button onClick={() => onCancel()}>Cancel</Button>
                </Flex>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
